import { notificationIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const markNotificationRead = {
  name: "markNotificationRead" as const,
  input: z.union([
    z.object({
      notificationId: notificationIdFormat.schema,
      all: z.never().optional(),
    }),
    z.object({ all: z.literal(true), notificationId: z.never().optional() }),
  ]),
  output: z.object({ success: z.boolean() }),
};
